import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { CookieConsent } from "./components/legal/CookieConsent";
import { InstallPrompt } from "./components/InstallPrompt";
import { OfflineIndicator } from "./components/OfflineIndicator";
import { BrowserCompatibilityChecker } from "./components/BrowserCompatibilityChecker";
import Index from "./pages/Index";
import Home from "./pages/Home";
import Auth from "./pages/Auth";
import CreatorDashboard from "./pages/CreatorDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminBlogManagement from "./pages/AdminBlogManagement";
import GoLive from "./pages/GoLive";
import StreamPlayer from "./pages/StreamPlayer";
import Wallet from "./pages/Wallet";
import Profile from "./pages/Profile";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import CSAEPolicy from "./pages/CSAEPolicy";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Careers from "./pages/Careers";
import HelpCenter from "./pages/HelpCenter";
import Contact from "./pages/Contact";
import UserProfile from "./pages/UserProfile";
import Discovery from "./pages/Discovery";
import WatchRecording from "./pages/WatchRecording";
import NotFound from "./pages/NotFound";
import Search from "./pages/Search";
import Messages from "./pages/Messages";
import Analytics from "./pages/Analytics";
import Install from "./pages/Install";
import Referrals from "./pages/Referrals";
import Offline from "./pages/Offline";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
      <Toaster />
      <Sonner />
      <CookieConsent />
      <InstallPrompt />
      <OfflineIndicator />
      <BrowserCompatibilityChecker />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/discovery" element={<ProtectedRoute><Discovery /></ProtectedRoute>} />
            <Route path="/fan" element={<ProtectedRoute><Discovery /></ProtectedRoute>} />
            <Route path="/fan-dashboard" element={<ProtectedRoute><Discovery /></ProtectedRoute>} />
            <Route path="/search" element={<ProtectedRoute><Search /></ProtectedRoute>} />
            <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
            <Route path="/analytics" element={<ProtectedRoute requiredRole="admin"><Analytics /></ProtectedRoute>} />
            <Route path="/creator" element={<ProtectedRoute requiredRole="creator"><CreatorDashboard /></ProtectedRoute>} />
            <Route path="/creator-dashboard" element={<ProtectedRoute requiredRole="creator"><CreatorDashboard /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><CreatorDashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/blog" element={<ProtectedRoute requiredRole="admin"><AdminBlogManagement /></ProtectedRoute>} />
            <Route path="/go-live" element={<ProtectedRoute requiredRole="creator"><GoLive /></ProtectedRoute>} />
            <Route path="/stream/:id" element={<ProtectedRoute><StreamPlayer /></ProtectedRoute>} />
            <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/profile/:username" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/csae-policy" element={<CSAEPolicy />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/user/:userId" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
            <Route path="/watch/:id" element={<ProtectedRoute><WatchRecording /></ProtectedRoute>} />
            <Route path="/install" element={<Install />} />
            <Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
            <Route path="/offline" element={<Offline />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
